

























import { defineComponent } from "@vue/composition-api";
import BaseIcon from "@/components/Base/BaseIcon";
import BaseButton from "@/components/BaseButton";
import BaseSpinner from "@/components/BaseSpinner";

export default defineComponent({
  name: "CreatePostMinimizedView",
  components: { BaseSpinner, BaseButton, BaseIcon },
  props: {
    errorUploadingFile: { type: Boolean, default: false },
    isPublished: { type: Boolean, default: false },
    uploadedFilesNumber: { type: Number, default: 0 },
    totalFiles: { type: Number, required: true },
  },
});
